import FormValidator from '../../../../helper/formValidator';

const validator = new FormValidator([
  {
    field: 'foundation',
    method: 'isEmpty',
    validWhen: false,
    message: 'اجباری است'
  }
]);

export default validator;
